module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Italic.8d4a19f.woff2";